import React from "react";
import PropTypes from "prop-types";
import { useLocation, Link } from "react-router-dom";
import {
  Anchor,
  Divider,
  Type,
  Flex,
  UpdateBadge,
} from "@ebscois/react-component-library";
import NoDataMessage from "../../components/NoDataMessage";
import {
  StyledAlgorithmLogo,
  StyledTextContainer,
  UpdatesContainer,
} from "./_styled";
import { ALGORITHM_LOGO_URL } from "../../constants/ui";
import { updateTypes } from "../../constants/update-types";

const UpdatesTab = ({ updates }) => {
  const { pathname } = useLocation();
  const totalUpdates = updates?.length;
  return (
    <>
      {updates && updates.length > 0 ? (
        updates.map((update, idx) => {
          const date = update.badge
            ? new Date(update.badge.timestamp)
            : new Date(update.timestamp);
          return (
            <UpdatesContainer data-testid="content-updates-container">
              {update.badge ? (
                <UpdateBadge
                  priority={update.badge.priority}
                  subPriorityText={update.badge.subPriorityText}
                  showSubPriority={update.badge.healthEquity}
                  timestamp={update.badge.timestamp}
                  text={update.badge.updateType}
                />
              ) : (
                <Type
                  color="gray800"
                  element="p"
                  data-testid="updates-date"
                  paddingTop="xs"
                  paddingLeft="xs"
                >
                  {date.getDate()}{" "}
                  {date.toLocaleString("en-US", { month: "short" })}{" "}
                  {date.getFullYear()}
                </Type>
              )}
              <Flex container row marginTop="xs">
                {update.badge?.updateType === updateTypes.ALGORITHM && (
                  <StyledAlgorithmLogo
                    alt="Algorithm logo"
                    src={ALGORITHM_LOGO_URL}
                  />
                )}
                <StyledTextContainer>
                  <Type
                    color="gray800"
                    element="p"
                    data-testid="content-updates-text"
                  >
                    {update.text}
                  </Type>
                  {update.badge?.updateType !==
                    updateTypes.TOPIC_LITERATURE_REVIEW && (
                    <Anchor
                      linkComponent={Link}
                      href={`${pathname.substring(
                        0,
                        pathname.lastIndexOf("/")
                      )}#${update.linkId}`}
                    >
                      View in topic
                    </Anchor>
                  )}
                </StyledTextContainer>
              </Flex>

              {idx !== totalUpdates - 1 && (
                <Divider data-testid="updates-divider" />
              )}
            </UpdatesContainer>
          );
        })
      ) : (
        <NoDataMessage message={"No updates available"} />
      )}
    </>
  );
};

UpdatesTab.propTypes = {
  updates: PropTypes.shape({
    text: PropTypes.string,
    linkId: PropTypes.string,
    badge: PropTypes.shape({
      updateType: PropTypes.string,
      priorityText: PropTypes.string,
      icon: PropTypes.shape({
        glyph: PropTypes.string,
        info: PropTypes.string,
      }),
    }),
  }),
};

UpdatesTab.displayName = "UpdatesTab";
export default React.memo(UpdatesTab);
